exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-box[data-v-56100717]{position:center;width:50%;min-width:1000px;margin:50px auto;box-shadow:0 2px 8px 0 rgba(0,0,0,.1);min-height:500px}.content-body[data-v-56100717]{padding:0 50px 0 40px}.search-box .el-input__inner[data-v-56100717]{width:221px;height:34px;line-height:34px}.el-input[data-v-56100717],.el-textarea[data-v-56100717]{width:300px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-56100717","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ticket/tickets.vue
// module id = 960
// module chunks = 0